/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_HealthInputs */

const en_val_health = /** @type {(inputs: Val_HealthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Health`)
};

const es_val_health = /** @type {(inputs: Val_HealthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salud`)
};

const fr_val_health = /** @type {(inputs: Val_HealthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Santé`)
};

const de_val_health = /** @type {(inputs: Val_HealthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesundheit`)
};

const ja_val_health = /** @type {(inputs: Val_HealthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ヘルスコーチング`)
};

const zh_val_health = /** @type {(inputs: Val_HealthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`健康指导`)
};

const ar_val_health = /** @type {(inputs: Val_HealthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`صحة`)
};

const id_val_health = /** @type {(inputs: Val_HealthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kesehatan`)
};

const it_val_health = /** @type {(inputs: Val_HealthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salute`)
};

const ru_val_health = /** @type {(inputs: Val_HealthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Здоровье`)
};

const pt_val_health = /** @type {(inputs: Val_HealthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saúde`)
};

const ko_val_health = /** @type {(inputs: Val_HealthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`헬스/건강`)
};

/**
* | output |
* | --- |
* | "Health" |
*
* @param {Val_HealthInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_health = /** @type {((inputs?: Val_HealthInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_HealthInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_health(inputs)
	if (locale === "es") return es_val_health(inputs)
	if (locale === "fr") return fr_val_health(inputs)
	if (locale === "de") return de_val_health(inputs)
	if (locale === "ja") return ja_val_health(inputs)
	if (locale === "zh") return zh_val_health(inputs)
	if (locale === "ar") return ar_val_health(inputs)
	if (locale === "id") return id_val_health(inputs)
	if (locale === "it") return it_val_health(inputs)
	if (locale === "ru") return ru_val_health(inputs)
	if (locale === "pt") return pt_val_health(inputs)
	return ko_val_health(inputs)
});